import React from 'react';
import { Flex, Separator, Text } from '@chakra-ui/react';
import { formatCurrency } from '@/utils/domain/currency';
import type { Currency } from '@/constants/currency/currency';
import type { CartCouponResponse } from '@/models/cart/cart';

interface PriceCalculatorProps {
  subtotal: number;
  deliveryFee: number;
  totalPrice: number;
  totalDiscount: number;
  currency: Currency;
  coupons: CartCouponResponse[];
  isFreeShipping?: boolean;
}

const CartOrderSummary = ({
  subtotal,
  deliveryFee,
  totalPrice,
  totalDiscount,
  currency,
  coupons,
  isFreeShipping = false,
}: PriceCalculatorProps) => {
  const formattedSubtotal = formatCurrency(currency, (subtotal * 0.01).toFixed(2));
  const formattedDeliveryFee = formatCurrency(currency, (deliveryFee * 0.01).toFixed(2));
  const formattedTotalPrice = formatCurrency(currency, (totalPrice * 0.01).toFixed(2));

  return (
    <Flex flexDirection="column" gap={2}>
      <Flex flexDirection="column" gap={2}>
        <Flex alignItems="center" justifyContent="space-between">
          <Text textStyle="body3">Subtotal:</Text>
          <Text textStyle="body3">{formattedSubtotal}</Text>
        </Flex>
        {coupons.length > 0 &&
          coupons.map((coupon) => (
            <Flex alignItems="center" justifyContent="space-between" key={coupon.code}>
              <Text textStyle="body3">{coupon.code}:</Text>
              <Text textStyle="body3">-{formatCurrency(currency, (totalDiscount * 0.01).toFixed(2))}</Text>
            </Flex>
          ))}
        <Flex alignItems="center" justifyContent="space-between">
          <Text textStyle="body3">Delivery Fee:</Text>
          {isFreeShipping || deliveryFee === 0 ? (
            <Text color="brand.60" textStyle="body3" textTransform="uppercase">
              Free
            </Text>
          ) : (
            <Text textStyle="body3">{formattedDeliveryFee}</Text>
          )}
        </Flex>
      </Flex>
      <Separator />
      <Flex alignItems="center" justifyContent="space-between">
        <Text fontWeight="bold" textStyle="body1">
          Order Total:
        </Text>
        <Text fontWeight="bold" textStyle="body1">
          {formattedTotalPrice}
        </Text>
      </Flex>
    </Flex>
  );
};

export default CartOrderSummary;
